import React from 'react';
import Icon from '../../../components/AppIcon';

const SupportMetricsCard = ({ title, value, change, changeType, icon, target, unit = "" }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-text-secondary';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1 dashboard-fade-in">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name={icon} size={20} className="text-primary" />
          </div>
          <h3 className="text-sm font-medium text-text-secondary">{title}</h3>
        </div>
        {target && (
          <div className="text-xs text-text-secondary">
            Target: {target}{unit}
          </div>
        )}
      </div>
      
      <div className="space-y-2">
        <div className="flex items-baseline space-x-2">
          <span className="text-2xl font-bold text-text-primary">
            {value}{unit}
          </span>
          {change && (
            <div className={`flex items-center space-x-1 ${getChangeColor()}`}>
              <Icon name={getChangeIcon()} size={14} />
              <span className="text-sm font-medium">{change}</span>
            </div>
          )}
        </div>
        
        {target && (
          <div className="w-full bg-muted rounded-full h-2">
            <div 
              className={`h-2 rounded-full transition-all duration-300 ${
                parseFloat(value) >= parseFloat(target) ? 'bg-success' : 'bg-warning'
              }`}
              style={{ 
                width: `${Math.min((parseFloat(value) / parseFloat(target)) * 100, 100)}%` 
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SupportMetricsCard;